import OrderTransportingOrderAvailableConsumersRequest from "../../../../api/raily/order/transporting-order/available-consumers/order-transporting-order-available-consumers.request";
import OrderTransportingOrderAvailableConsumersParams from "./order-transporting-order-available-consumers-params";

const create = (
  params: OrderTransportingOrderAvailableConsumersParams,
): OrderTransportingOrderAvailableConsumersRequest => {
  return {
    transportingOrderUuid: params.transportingOrderUuid,
  };
};

const orderTransportingOrderAvailableConsumersParamsFactory = {
  create,
};

export default orderTransportingOrderAvailableConsumersParamsFactory;
